export default {
    "cookies": {
        "title": "Use of cookies",
        "description": "We use cookies, including third-party cookies, to collect information about how visitors use our websites. They help us to give you the best possible experience, continually improve our sites and provide you with commercial information that is tailored to your interests. By clicking the 'Accept all' button, you accept the use of these cookies. You can withdraw your consent at any time, change your preferences and obtain detailed information about our use of",
        "link": "cookies by consulting our Cookies Policy",
        "btnConfig": "Set cookies",
        "btnAccept": "Accept all"
    },
    crossword: {
        misteriousCharacter: "misterious character",
        horizontal: "Horizontal",
        vertical: "Vertical",
        empty: "Fill in the complete crossword puzzle to participate",
        formTitle: "Complete the crossword puzzle and submit the form to participate in the drawing",
        successMessage: {
            title: "Your form has been sent successfully",
            message: "Best of luck and thanks for participating!"
        }
    }
}
